import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getTeamMemberById } from "../api/team.api";
import { Helmet } from 'react-helmet';
import "../index.css"; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

export default function TeamDetails() {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const data = await getTeamMemberById(id);
        if (mounted) setMember(data);
      } catch (err) {
        setError("Member not found.");
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => { mounted = false; };
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{color:"red"}}>{error}</p>;
  if (!member) return null;

  return (
    <>
    <Helmet>
      <title>LCWE | {member.name}</title>
    </Helmet>
    <div className="container-fluid position-relative p-0">
        <div className="container-fluid bg-primary py-2 bg-header" style={{marginBottom:20, backgroundColor:"#15415c"}}>
            <div className="row py-5">
                <div className="col-12 pt-lg-2 mt-lg-2 text-center">
                    <h1 className="display-4 text-white animated zoomIn">LCWE Team</h1>
                    <Link to="/" className="h5 text-white">Home</Link>
                    <i className="bi bi-circle text-white px-2"></i>
                    <Link to="/team" className="h5 text-white">Team</Link>
                </div>
            </div>
        </div>
      </div>
    <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
            <div className="section-title position-relative pb-3 " style={{maxWidth:600}}>
                <h2 className="fw-bold text-primary text-uppercase">{member.name}</h2>
                <h4 className="mb-0">{member.position}</h4>
            </div>
            <div className="row g-5 py-5">
                <div className="col-lg-5">
                    <div className="mb-5">
                        <img className="img-fluid w-100 rounded mb-5" src={`https://node.lcwe-lb.com/uploads/images/${member.photo}`} alt={member.name} />
                    </div>
                </div>
                <div className="col-lg-7">
                    <div className="mb-5">
                        <h4 className="mb-4">Education:</h4>
                        {member.education && member.education.includes("/")
                        ? (
                        <ul>
                            {member.education.split("/").map((obj, idx) => (
                            <li key={idx}>{obj.trim()}</li>
                            ))}
                        </ul>
                        )
                        : (
                        <p>{member.education}</p>
                        )}
                        <h4 className="mb-4">Expertise:</h4>
                        {member.bio && member.bio.includes("/")
                        ? (
                        <ul>
                            {member.bio.split("/").map((obj, idx) => (
                            <li key={idx}>{obj.trim()}</li>
                            ))}
                        </ul>
                        )
                        : (
                        <p>{member.bio}</p>
                        )}
                        <div className="col-lg-4 col-md-6">
                            <a
                                href={`https://node.lcwe-lb.com/uploads/reports/${member.cv}`}
                                target="_blank"
                                className="btn btn-primary py-2 px-4"
                            >
                                View CV
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
}
